// Helper to build R2 public folder URL for media
export function getMediaUrl(filename) {
  if (!filename) return '';
  const r2Base = 'https://pub-0705ed3bb3a5425799ba64b1bd76a81b.r2.dev/shared_media';

  // If an object with a url is passed, try to canonicalize it
  if (typeof filename === 'object' && filename !== null) {
    if (filename.url) return filename.url;
    if (filename.publicId || filename.public_id) {
      const pid = (filename.publicId || filename.public_id || '').replace(/^shared_media\//, '');
      const parts = pid.split('/').filter(Boolean);
      const last = parts[parts.length - 1] || pid;
      return `${r2Base}/${encodeURIComponent(last)}`;
    }
    if (filename.name) return `${r2Base}/${encodeURIComponent(filename.name)}`;
  }

  // If a full URL string is passed, assume it's already canonical
  if (typeof filename === 'string') {
    const trimmed = filename.trim();
    if (trimmed === '') return '';
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
      return trimmed;
    }

    // treat as a basename or path; take last segment
    const parts = trimmed.split('/').filter(Boolean);
    const last = parts[parts.length - 1] || trimmed;
    return `${r2Base}/${encodeURIComponent(last)}`;
  }
  return '';
}
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
